module.exports = __webpack_public_path__ + "img/partner-glints.949360c5.png";